import { Path } from '../api/config.js';
import { PlayerPresentationStatus } from '../api/presentation.js';

let playerOptionsRequests = {};

/**
 * Returns a Promise that resolves to a collection of data from GetPlayerOptions.
 * @param {string} resourceId
 * @returns {Promise<Object>}
 */
export function getPlayerOptions(resourceId) {
    if (!playerOptionsRequests[resourceId]) {
        let urlReferrer = null;
        if (window.self != window.top) {
            try {
                let containerUrl = window.parent.document.location.href;
                if (containerUrl) urlReferrer = containerUrl;
            } catch { }
        }
        playerOptionsRequests[resourceId] = fetch(`${Path.PlayerService}/GetPlayerOptions`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            mode: 'cors',
            body: JSON.stringify({
                "getPlayerOptionsRequest": {
                    "QueryString": location.search,
                    "ResourceId": resourceId,
                    "UrlReferrer": urlReferrer
                }
            })
        }).then(result => result.json().then(jsonData => {
            if (!result.ok) {
                throw Error(jsonData?.Message);
            }
            if (jsonData.d.PlayerPresentationStatus === PlayerPresentationStatus.NotAuthorized ||
                jsonData.d.PlayerPresentationStatus === PlayerPresentationStatus.NotYetAvailable ||
                jsonData.d.PlayerPresentationStatus === PlayerPresentationStatus.NotFound) {
                throw Error(jsonData.d.PlayerPresentationStatusMessage);
            } else if (jsonData.d.PlayerPresentationStatus === PlayerPresentationStatus.Viewable) {
                delete playerOptionsRequests[resourceId];
                return jsonData;
            }
            else if (jsonData.d.LoginUrl) {
                window.location = `${jsonData.d.LoginUrl}?ReturnUrl=${encodeURIComponent(window.location)}`
                return new Promise();
            }
        }));
    }
    return playerOptionsRequests[resourceId];
}

/**
 * Todo: modernize GetPlayerOptions
 * 
 * The GetPlayerOptions API returns a large JSON object with many properties to sift through. As
 * a result, it's rather unweildly because it contains a lot of information we don't always need.
 * 
 * It also returns different data structures depending on a few server-side conditions, so the
 * JSON response object doesn't necessarily always have the same set of properties.
 * 
 * The various functions in src/api/ use this helper to to request data from GetPlayerOptions with less boilerplate.
 * They should ultimately be updated to get their data from actual specialized API endpoints once they
 * are developed.
 * 
 */
